import { render, staticRenderFns } from "./ProgManage.vue?vue&type=template&id=6275c184&"
import script from "./ProgManage.vue?vue&type=script&lang=js&"
export * from "./ProgManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports